import { Factory, Anchor, ClipboardCheck, Ship, Package, BadgeCheck, CircleCheck, MapPin } from "lucide-react";

const MAP = {
  factory: Factory,
  anchor: Anchor,
  "clipboard-check": ClipboardCheck,
  ship: Ship,
  package: Package,
  "badge-check": BadgeCheck,
  "circle-check": CircleCheck,
};

export const EtapaIcon = ({ nombre, ...props }) => {
  const Comp = MAP[nombre] || MapPin;
  return <Comp {...props} />;
};
